import moment from 'moment-timezone';
import {
  noValueVFTextarea,
  VF_TEXTAREA,
} from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  noValueVFButtonSelector,
  VF_BUTTON_SELECTOR,
} from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  noValueVFDropdown,
  VF_DROPDOWN,
} from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  noValueVFInput,
  VF_INPUT,
} from 'AppSrc/core/components/forms/form-base-components/v-f-input';
import {
  noValueVFModal,
  VF_MODAL,
} from 'AppSrc/core/components/forms/form-base-components/v-f-modal';
import {
  noValueVFDropzone,
  VF_DROPZONE,
} from 'AppSrc/core/components/forms/form-base-components/v-f-dropzone';
import {
  noValueDatePicker,
  VF_DATE_PICKER,
} from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import {
  noValueCorrectiveDatePicker,
  VF_CORRECTIVE_DATE_PICKER,
} from 'AppSrc/core/components/forms/form-base-components/v-f-corrective-date-picker';
import {
  noValueVFMultiSelect,
  VF_MULTI_SELECT,
} from 'AppSrc/core/components/forms/form-base-components/v-f-multi-select';
import {
  VF_LOOKUP_TABLE,
  noValueVFLookupTable,
} from 'AppSrc/core/components/forms/form-base-components/v-f-lookup-table';
import {
  VF_RADIO_BUTTON,
  noValueVFRadioButton,
} from 'AppSrc/core/components/forms/form-base-components/v-f-radio-button';
import {
  VF_SINGLE_RADIO,
  noValueVFSingleRadio,
} from 'AppSrc/core/components/forms/form-base-components/v-f-single-radio';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import { isEmpty } from 'underscore';
import { APPROVERS_SECTION } from '../../form-types/create-crq/form-definition/section-constants';
import { CRQ_STATUSES } from '../../../../crq/crq-statuses';

const INLINE_ERRORS = 'inlineErrors';
const MODAL_ERRORS = 'modalErrors';
// Silent errors should prevent submit, but are not
// fed back to the user. This is useful for modal forms
// such as add approvers
const SILENT_ERRORS = 'silentErrors';

const errorTypes = [
  INLINE_ERRORS,
  MODAL_ERRORS,
  SILENT_ERRORS,
];

const noValueCheck = {
  [VF_TEXTAREA]: noValueVFTextarea,
  [VF_BUTTON_SELECTOR]: noValueVFButtonSelector,
  [VF_DROPDOWN]: noValueVFDropdown,
  [VF_INPUT]: noValueVFInput,
  [VF_MODAL]: noValueVFModal,
  [VF_DROPZONE]: noValueVFDropzone,
  [VF_DATE_PICKER]: noValueDatePicker,
  [VF_CORRECTIVE_DATE_PICKER]: noValueCorrectiveDatePicker,
  [VF_MULTI_SELECT]: noValueVFMultiSelect,
  [VF_LOOKUP_TABLE]: noValueVFLookupTable,
  [VF_RADIO_BUTTON]: noValueVFRadioButton,
  [VF_SINGLE_RADIO]: noValueVFSingleRadio,
};

const noValue = (value, fieldType) => {

  if (value === undefined) {
    // FN: 3/12/2019
    // This is unlikely to occur but if it does, check that the field has an initial value set
    console.warn('Values should not be "undefined" by the time validation occures.');
    // return true to trigger the error message
    return true;
  }

  const noValueFound = noValueCheck[fieldType](value);
  return noValueFound;
};

const date = {
  isBeforeMinDate(thisDate, minDate) {
    const minMoment = moment.tz(minDate, DEFAULT_TIMEZONE);
    const thisMoment = moment.tz(thisDate, DEFAULT_TIMEZONE);
    return thisMoment.isBefore(minMoment);
  },
  isAfterMaxDate(thisDate, maxDate) {
    const maxMoment = moment.tz(maxDate, DEFAULT_TIMEZONE);
    const thisMoment = moment.tz(thisDate, DEFAULT_TIMEZONE);
    return thisMoment.isAfter(maxMoment);
  },
};

const textInput = {
  isOverCharacterLimit(value, characterLimit) {
    if (value) {
      return value.length > characterLimit;
    }
    return false;
  },
  isUnderCharacterMinimum(value, minCharacters) {
    return value.length < minCharacters;
  },
  hasBadFormat(value, formatRegex) {
    return formatRegex.test(value) === false;
  },
  isValidContact(value, formatRegex) {
    const isInvalid = formatRegex.test(value);
    return isInvalid;
  },
  // Special character validation removed now, later if its required can be used
  // hasSpecialCharacter(value) {
  //   const pattern = /</g;
  //   const res = pattern.test(value);
  //   return res;
  // },
};

const commonValidation = {
  noValue,
  date,
  textInput,
};




/* FUNCTIONS FOR CLEANING UP ERROR OBJECTS */

const getDefaultFieldErrors = () => ({
  [INLINE_ERRORS]: [],
  [MODAL_ERRORS]: [],
  [SILENT_ERRORS]: [],
});


// Formik reads any key within an error object as being "there is an error". As such,
// if we don't have errors, we need to clean up the object. The following function does
// this for fields:
// `{errors: { someField: { inlineErrors: []} }}` goes to `{errors: { someField: {}}}`
// as well as:
// `{errors: { someField: { inlineErrors: [null]} }}` goes to `{errors: { someField: {}}}`
const cleanUpFieldErrors = (errors) => {
  const formattedErrors = {};
  // removes null values
  errorTypes.forEach((errorType) => {
    formattedErrors[errorType] = errors[errorType].filter((error) => error);
    if (formattedErrors[errorType].length < 1) {
      delete formattedErrors[errorType];
    }
  });

  return formattedErrors;
};


// Formik reads any key within an error object as being "there is an error". As such,
// if we don't have errors, we need to clean up the object. The following function does
// this for sections:
// `{errors: { someField: {}, someOther: { someError: '404'} }}`
// goes to:
// `{errors: { someOther: { someError: '404'} }}`
const cleanUpSectionErrors = (errors) => {
  const formattedErrors = {};
  const objectKeys = Object.keys(errors);
  objectKeys.forEach((key) => {
    if (!isEmpty(errors[key])) {
      formattedErrors[key] = errors[key];
    }
  });
  return formattedErrors;
};

/*
  return an array of error messages data to show at the top of the summary page
  each entry is of the form: {
    sectionTitle: 'Section title',
    fieldTitle: 'Field title',
    errorMessages: ['message1', 'message2']
  }
*/
const collectErrors = (params) => {
  const {
    formData,
  } = params;
  if (!formData || !formData.summaryErrors) {
    return [];
  }
  const { summaryErrors, formSectionsByDisplayOrder, dataByFormSectionId } = formData;
  const { status } = formData;
  const errors = {};
  const inlineErrors = [];
  const modalErrors = [];
  formSectionsByDisplayOrder.forEach((sectionId) => {
    const sectionData = dataByFormSectionId[sectionId];
    const { sectionTitle, fieldIdsByDisplayOrder } = sectionData;
    let sectionErrors;
    const isApproverAdded = window.sessionStorage.getItem('isApproverAdded');
    // Approver Groups are get from sessionStorage to false the Approvers section error after Approvers added
    if (sectionId === APPROVERS_SECTION && status === CRQ_STATUSES.coordinator && isApproverAdded === 'true') {
      sectionErrors = false;
    }
    else {
      sectionErrors = summaryErrors[sectionId];
    }
    if (sectionErrors) {
      fieldIdsByDisplayOrder.forEach((fieldId) => {
        const fieldErrors = sectionErrors[fieldId];
        // we are interested in all error types
        // if there are any, add an entry to the array
        // INLINE_ERRORS,
        // MODAL_ERRORS,

        if (fieldErrors) {
          if (fieldErrors[INLINE_ERRORS]) {
            const fieldData = sectionData.dataByFieldId[fieldId];
            const { fieldTitle } = fieldData;
            inlineErrors.push({
              sectionTitle,
              fieldTitle,
              errorMessages: fieldErrors[INLINE_ERRORS],
            });
          }

          if (fieldErrors[MODAL_ERRORS]) {
            const fieldData = sectionData.dataByFieldId[fieldId];
            const { fieldTitle } = fieldData;
            const {
              modalSummaryType,
              modalErrorsTitle,
            } = fieldData.vFTypeSpecificOptions;

            modalErrors.push({
              modalSummaryType,
              modalErrorsTitle,
              sectionTitle,
              fieldTitle,
              errorMessages: fieldErrors[MODAL_ERRORS],
            });
          }
        }
      });

    }
  });
  errors[INLINE_ERRORS] = inlineErrors;
  errors[MODAL_ERRORS] = modalErrors;

  return errors;
};

const getHasErrors = (errors) => {
  const hasInlineErrors = errors[INLINE_ERRORS].length > 0;
  const hasModalErrors = errors[MODAL_ERRORS].length > 0;
  return hasInlineErrors || hasModalErrors;
};



export {
  commonValidation,
  cleanUpFieldErrors,
  cleanUpSectionErrors,
  getDefaultFieldErrors,
  INLINE_ERRORS,
  MODAL_ERRORS,
  SILENT_ERRORS,
  errorTypes,
  collectErrors,
  getHasErrors,
};
